import { isActionOf, getType } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { RootEpic } from '../types'
import { getUserWalletsFailure, getUserWalletsRequest, getUserWalletsSuccess } from '../actions'

export const fetchUserWalletsEpic: RootEpic = (action$, state$, { fetchUserWallets }) => {
  return action$.pipe(
    filter(isActionOf([getUserWalletsRequest])),
    switchMap(({ type, payload }) =>
      from(
        fetchUserWallets({
          token: state$.value.app.authToken as string,
          // eslint-disable-next-line
          userIdSf: (payload as any).idSf,
          limit: 10,
          ...state$.value.sfWallets.filters,
          ...(type === getType(getUserWalletsRequest) && payload),
        }),
      ).pipe(
        map((response) => getUserWalletsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch wallets.')
          return of(getUserWalletsFailure(message))
        }),
      ),
    ),
  )
}

export default [fetchUserWalletsEpic]
